import React from "react";
import ButtonScrollTo from "components/button-scroll-to/ButtonScrollTo";
import hospitalIcon from "assets/products/shared/icons/hospital-syringes.svg";
import atHomeIcon from "assets/products/shared/icons/at-home-icon.svg";
import erIcon from "assets/products/shared/icons/er-icon.svg";
import airlineIcon from "assets/products/shared/icons/airline-icon.svg";
import vehicleIcon from "assets/products/shared/icons/vehicle-icon.svg";
import otherIcon from "assets/products/shared/icons/other-icon.svg";

interface MorePeaceOfMindProps {
    className?: string;
}

const MorePeaceOfMind = ({ className = "" }: MorePeaceOfMindProps) => {
    const features = [
        {
            image: hospitalIcon,
            title: "Hospital stays",
            ref: "⁹",
            benefit_1: "While traveling: Up to $1500/day",
            benefit_2: "Other Accidents: Up to $375/day",
        },
        {
            image: atHomeIcon,
            title: "At-home recovery",
            ref: "⁹",
            benefit_1: "While traveling: Up to $1500/day",
            benefit_2: "Other Accidents: Up to $375/day",
        },
        {
            image: erIcon,
            title: "ER/urgent care treatment",
            ref: "",
            benefit_1: "While traveling: Up to $1500/day",
            benefit_2: "Other Accidents: Up to $375/day",
        },
        {
            image: airlineIcon,
            title: "Loss of life – airline accident",
            ref: "",
            benefit_1: "Up to $500,000",
            benefit_2: "",
        },
        {
            image: vehicleIcon,
            title: "Loss of life – vehicle accident",
            ref: "⁸",
            benefit_1: "Up to $250,000",
            benefit_2: "",
        },
        {
            image: otherIcon,
            title: "Loss of life – other accidents",
            ref: "",
            benefit_1: "Up to $62,500",
            benefit_2: "",
        },
    ];

    return (
        <div className={`bg-base-content w-full p-6 tablet:py-12 ${className}`}>
            <div className="max-w-[1200px] mx-auto text-center justify-items-center">
                <div className="text-3xl tablet:text-5xl font-semibold tablet:font-normal text-primary-content leading-9">
                    More peace of mind for life's adventures
                </div>
                <div className="text-primary-content max-w-[790px] text-base font-medium leading-6 justify-center mt-4">
                    Member Loyalty<sup>®</sup> Accident Insurance provides cash benefits for injuries sustained in accidents,
                    and your benefits grow with your years of AAA membership. Members who have been part of AAA for five years
                    or more are eligible for the highest benefit level, which includes the following important benefits:
                </div>
                <div className="grid grid-cols-1 tablet:grid-cols-3 gap-6 py-6 justify-start w-full">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="flex flex-col bg-base-100 text-left rounded-lg px-4 py-4 font-sans leading-7"
                        >
                            <img src={feature.image} alt="" className="w-4 h-4" />
                            <div className="text-base-content text-lg tablet:text-xl font-semibold">
                                {feature.title}
                                <a href="#disclosures" className="text-primary hover:underline">
                                    <span className="text-blue-700">{feature.ref}</span>
                                </a>
                            </div>
                            <div className="text-accent tablet:text-lg text-md font-bold">{feature.benefit_1}</div>
                            <div className="text-accent tablet:text-lg text-md font-bold">{feature.benefit_2}</div>
                        </div>
                    ))}
                </div>
                <div className="flex justify-center py-2">
                    <ButtonScrollTo {...{ id: "term-banner-content", text: "Get Started", style: "primary" }} />
                </div>
            </div>
        </div>
    );
};

export default MorePeaceOfMind;
